import * as React from 'react'

import { Moon, Sun } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { useTheme } from '@/components/theme-provider'
import { useTranslation } from 'react-i18next'

export function ThemeToggle() {
	const { theme, setTheme } = useTheme()
	const { t } = useTranslation()

	const toggleTheme = () => {
		setTheme(theme === 'light' ? 'dark' : 'light')
	}

	return (
		<Button variant='outline' size='icon' onClick={toggleTheme} className='shadow-none'>
			<Sun className='h-4 w-4 rotate-0 scale-100 transition-all dark:rotate-90 dark:scale-0' />
			<Moon className='absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100' />
			<span className='sr-only'>{t('common.toggleTheme')}</span>
		</Button>
	)
}
